"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _withdrawPlan = _interopRequireDefault(require("./_withdrawPlan"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    withdrawPlan: _withdrawPlan.default
  },
  data: function data() {
    return {
      form: {
        drawbacke_now_cdb: 1,
        drawbacke_now: 1,
        agent_withdraw_type: [],
        agent_withdraw_plan: [],
        merchant_withdraw_plan: []
      },
      form_key: {
        ent_name: '',
        org_code: '',
        drawbacke_now_cdb: 1,
        cdb_drawbacke_balance: '',
        cdz_drawbacke_balance: '',
        drawbacke_hours_cdb: '',
        drawbacke_now: 1,
        drawbacke_2_balance: '',
        drawbacke_hours: '',
        agent_withdraw_type: [],
        agent_audit_min_yuan: '',
        agent_tx_day_num: '',
        merchant_tx_day_num: '',
        agent_withdraw_fee_type: '',
        agent_withdraw_percent: '',
        agent_withdraw_fee: '',
        merchant_audit_min_yuan: '',
        merchant_withdraw_fee_type: '',
        merchant_withdraw_percent: '',
        merchant_withdraw_fee: '',
        user_audit_min_yuan: '',
        user_withdraw_percent: '',
        free_rent_minutes: '',
        register_user_moblie: '',
        first_free_right: '',
        agent_withdraw_min_yuan: '',
        agent_withdraw_max_yuan: '',
        merchant_withdraw_min_yuan: '',
        merchant_withdraw_max_yuan: '',
        user_withdraw_min_yuan: '',
        user_withdraw_max_yuan: '',
        expired_bao_cost_price: '',
        expired_thread_cost_price: '',
        user_withdraw_by_refund: 0,
        order_profits_detail_show: 1,
        sell_goods_switch: 0,
        selled_goods_bind_sid: ''
      },
      powerInfo: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.setInfo();
    this.$get('agentapi/add_agent').then(function (res) {
      _this.powerInfo = res;
    });
  },
  methods: {
    /**
     * 获取信息
     */
    setInfo: function setInfo() {
      var _this2 = this;
      this.$get('agentapi/get_partner_config', {}).then(function (res) {
        var plan = [{
            week_day: 0,
            month_day: 1,
            begin: '00:00',
            end: '24:00'
          }],
          params = {
            agent_withdraw_date_type: 0,
            agent_withdraw_plan: plan,
            merchant_withdraw_date_type: 0,
            merchant_withdraw_plan: plan
          };
        for (var i in _this2.form_key) {
          params[i] = res[i];
        }
        if (params.drawbacke_time) params.drawbacke_hours = params.drawbacke_time / 60 / 60;
        if (res.withdraw_plan && res.withdraw_plan.agent) {
          if (res.withdraw_plan.agent.plan.length > 0) {
            params.agent_withdraw_plan = res.withdraw_plan.agent.plan;
          }
          params.agent_withdraw_date_type = res.withdraw_plan.agent.date_type;
        }
        if (res.withdraw_plan && res.withdraw_plan.merchant) {
          if (res.withdraw_plan.merchant.plan.length > 0) {
            params.merchant_withdraw_plan = res.withdraw_plan.merchant.plan;
          }
          params.merchant_withdraw_date_type = res.withdraw_plan.merchant.date_type;
        }
        _this2.form = params;
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;
      var params = JSON.parse(JSON.stringify(this.form)),
        url = 'agentapi/save_partner_setting';

      // 【操作埋点】2026-05-25 pc_setting_update_1 合伙人系统设置
      this.$post(url, params).then(function (res) {
        _this3.$post('agentapi/system/save_key_value', {
          sell_goods_switch: params.sell_goods_switch,
          selled_goods_bind_sid: params.selled_goods_bind_sid
        }).then(function (res) {
          _this3.$message({
            message: '提交成功',
            type: 'success'
          });
          _this3.$store.dispatch('user/getPlatformConfig');
          _this3.$settingReport.reportSettingUpdate('save_partner_setting', '合伙人系统设置', null, params);
        });
      });
    }
  }
};